(function () {
    "use strict";

    var Plan = function (options) {
        var defaults = {
            autoPayDiscount: 10,
            autoPayEnabled: true,
            data: 0,
            unlimitedTalk: true,
            stream: 1080,
            hotspot: true,
            autoPayPromotionPricing: false
        };

        $.extend(this, defaults, options);
    };

    Plan.prototype.hasAutoPayPromotionPricing = function () {
        return this.autoPayEnabled && this.autoPayPromotionPricing;
    };

    Plan.prototype.autoPayDiscountAmount = function () {
        return this.autoPayEnabled && this.autoPayDiscount || 0;
    };

    var Line = function (options) {
        var defaults = {
            active: false,
            multiLineDiscount: 0,
            plan: null
        };

        $.extend(this, defaults, options);
    };
    Line.prototype.totalBeforeDiscount = function () {
        return this.plan && this.plan.price || 0;
    };
    Line.prototype.multiLineDiscountAmount = function () {
        return this.multiLineDiscount || 0;
    };
    Line.prototype.autoPayDiscountAmount = function () {
        return this.plan && this.plan.autoPayDiscountAmount();
    };
    Line.prototype.discountAmount = function () {
        return this.multiLineDiscountAmount() + this.autoPayDiscountAmount();
    };
    Line.prototype.totalAfterDiscount = function () {
        return this.totalBeforeDiscount() - this.discountAmount();
    };

    app.service("CalculatorService", [
        "$rootScope", "settings", "TrackingService",
        function ($rootScope, settings, tracking) {
            var service = this;

            var activeLines = function () {
                return _.filter(service.lines, function (line) {
                    return line.active;
                });
            };

            var updatePlanAutoPay = function () {
                _.forEach(service.plans, function (plan) {
                    plan.autoPayEnabled = service.autoPayEnabled;
                });
            };

            var total = function (amount1, amount2) {
                return amount1 + amount2;
            };

            service.plans = _.map(settings.plans, function (plan) {
                return new Plan(plan);
            });

            service.lines = _.map(settings.lines, function (line) {
                return new Line(line);
            });

            service.autoPayEnabled = true;
            service.defaultPlan = _.find(service.plans, function (plan) {
                return plan.name === settings.defaultPlan;
            });
            service.minimumNumberOfLines = settings.minimumNumberOfLines;
            service.maximumNumberOfLines = settings.maximumNumberOfLines;
            service.numberOfLines = 0;

            service.toggleAutoPay = function () {
                service.autoPayEnabled = !service.autoPayEnabled;
                updatePlanAutoPay();
                tracking.trigger("Change AutoPay", service.autoPayEnabled ? "On" : "Off");
            };

            service.addLine = function () {
                if (service.numberOfLines < service.lines.length) {
                    var line = service.lines[service.numberOfLines];
                    line.plan = service.defaultPlan;
                    line.active = true;
                    service.numberOfLines += 1;
                    return true;
                }
            };

            service.removeLine = function () {
                if (service.numberOfLines > service.minimumNumberOfLines) {
                    var line = service.lines[service.numberOfLines - 1];
                    line.active = false;
                    line.plan = null;
                    line.showDetails = false;
                    service.numberOfLines -= 1;
                    return true;
                }
            };

            service.updateLine = function (line, plan) {
                line.plan = plan;
                tracking.trigger("Change line price", (plan && plan.price || 0) + "");
            };

            service.totalBeforeDiscount = function () {
                var activeCosts = _.map(activeLines(), function (line) {
                    return line.totalBeforeDiscount();
                });

                return _.reduce(activeCosts, total, 0);
            };

            service.discountAmount = function () {
                var activeDiscounts = _.map(activeLines(), function (line) {
                    return line.discountAmount();
                });

                return _.reduce(activeDiscounts, total, 0);
            };

            service.totalAfterDiscount = function () {
                var activeCosts = _.map(activeLines(), function (line) {
                    return line.totalAfterDiscount();
                });

                return _.reduce(activeCosts, total, 0);
            };

            service.totalMultiLineDiscount = function () {
                var activeDiscounts = _.map(activeLines(), function (line) {
                    return line.multiLineDiscountAmount();
                });

                return _.reduce(activeDiscounts, total, 0);
            };

            service.totalAutoPayDiscount = function () {
                var activeDiscounts = _.map(activeLines(), function (line) {
                    return line.autoPayDiscountAmount();
                });

                return _.reduce(activeDiscounts, total, 0);
            };

            service.initialize = function () {
                while (service.numberOfLines < service.minimumNumberOfLines) {
                    service.addLine();
                }
            };

            service.reset = function () {
                _.forEach(service.lines, function (line) {
                    line.plan = service.defaultPlan;
                });
                service.autoPayEnabled = true;
                updatePlanAutoPay();

                while (service.numberOfLines > service.minimumNumberOfLines) {
                    service.removeLine();
                }
                $rootScope.$broadcast("reset");
            };
        }
    ]);
})();